import { Accordion as MuiAccordion } from "@mui/material";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

type AccordionProps = {
  summary: any;
  content: any;
  defaultExpanded?: boolean;
};

export default function Accordion({
  summary,
  content,
  defaultExpanded,
}: AccordionProps) {
  return (
    <MuiAccordion defaultExpanded={defaultExpanded} elevation={5}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
      >
        {summary}
      </AccordionSummary>
      <AccordionDetails>{content}</AccordionDetails>
    </MuiAccordion>
  );
}
